// Resolves the plan a user is actually being served, mirroring the
// `subscription_effective_plan` view's override logic on the client.
//
// A manual override (comp account) wins while it is unexpired; otherwise the
// stored subscription plan applies. Kept as a pure helper so AuthContext,
// Billing and admin views all agree on one answer.

export interface EffectivePlanSource {
  plan?: string | null;
  manual_override_plan_key?: string | null;
  manual_override_expires_at?: string | null;
}

/** True when a manual plan override exists and has not lapsed. */
export function isOverrideActive(
  sub: EffectivePlanSource | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!sub?.manual_override_plan_key) return false;
  const expires = sub.manual_override_expires_at;
  if (!expires) return true;
  const ts = new Date(expires).getTime();
  return Number.isFinite(ts) && ts > now.getTime();
}

/** Plan key actually in force (override-aware). Falls back to "free". */
export function resolveEffectivePlanKey(
  sub: EffectivePlanSource | null | undefined,
  now: Date = new Date(),
): string {
  if (isOverrideActive(sub, now)) return sub!.manual_override_plan_key as string;
  return sub?.plan ?? "free";
}
